import { useCallback, useState } from 'react'
import { useApi } from '../useApi'
import { isErr } from '../../Utils/Result'
import { SearchResponse } from '../../Types/Search'

export const useSearch = () => {
  const { searchEndpoint } = useApi()
  const [loading, setLoading] = useState(false)
  const [results, setResults] = useState<SearchResponse | null>(null)
  const [error, setError] = useState<string | null>(null)

  const search = useCallback(async (params: { q: string; type?: 'all' | 'chats' | 'dd'; limit?: number; offset?: number }) => {
    setLoading(true)
    setError(null)
    const response = await searchEndpoint(params)
    setLoading(false)
    if (isErr(response)) { setError('Error al buscar'); return }
    setResults(response.value)
  }, [searchEndpoint])

  const clear = useCallback(() => { setResults(null); setError(null) }, [])

  return { search, results, loading, error, clear }
}
